import { useCallback, useEffect, useRef, useState } from 'react';
import { getLocale, shallowEqual, useDispatch, useSelector } from 'umi';
import { LANGUAGE_EN } from '../../_config/constant';
import { localeKeyMap } from '../../utils/utils';
import { getEventList } from '../../services/event';
import { useNewSelectorParams } from '../../utils/useNewSelectorParams';
import { FilterItemType } from '../../types/dashboard';

export const useFilterData = (path: string,timeType = 'daily', pageDefaultSelector: FilterItemType[], isUseFrontFilterConfig?:boolean) => {
  const [eventLoading, setEventLoading] = useState(true); // 筛选器loading
  const [eventError, setEventError] = useState(true); // 筛选器loading
  // 需求更改后，当前只有daily的粒度，所以暂不需要这个状态，后续需要的话在此基础上继续修改
  // const [metricsList,setMertricsList] = useState<{[key:string]:string}>();
  const [eventOptions, setEventOptions] = useState([]);
  const  {loading, getSelectorList} = useNewSelectorParams({
    realPath: path,
    pageDefaultSelector,
    isUseFrontFilterConfig: isUseFrontFilterConfig || false
  });
  const dispatch = useDispatch();
  // basicSelector暂时用不到先注释掉，后续支持日周月的时候需要用
  const gameCode = useSelector((state:any) => (state.dashboard?.currentGame?.game_code), shallowEqual);

  const selectorRef = useRef<any>({});

  const getEventListFunc = (startTime: string, endTime: string) => {
    setEventLoading(true);
    getEventList({
      game_code: gameCode,
      start_time: startTime,
      end_time: endTime,
      period: "daily",
      filter_event_date_field: 'start_time',
    }).then((res) => {
      setEventError(false);
      setEventOptions(res?.event_type || []);
    }).catch((e) => {
      console.log(e);
      setEventError(true);
    }).finally(() => {
      setEventLoading(false);
    });
  };

  useEffect(() => {
    getSelectorList().then((data)=>{
      const metricsList = data?.metrics_list?.[timeType] || [];
      selectorRef.current = { ...(data || {}), metrics_list: metricsList, gameCode };
      dispatch({
        type: 'dashboardSetting/save',
        payload: {
          selector: selectorRef.current,
        },
      });
    }).catch((e)=>{
      console.log(e);
    });
  }, []);

  return {
    loading,
    eventError,
    selector: selectorRef.current,
    getEventListFunc,
    eventOptions,
    eventLoading,
  };
};

// 筛选器数据中英文翻译
export const usePcDateSelectorMap = (selectorVal: any) => {
  const locale = getLocale();
  const { selectorMap, ...selector } = selectorVal || {};

  // 筛选器中英文翻译
  const usePcDateSelectorText = useCallback((regionDataType, key) => {
    const isEn = locale === LANGUAGE_EN;
    if (localeKeyMap[key?.toLowerCase()]) {
      return isEn ? key : localeKeyMap[key.toLowerCase()];
    }
    if (!selector) return key;
    const localeMap = selectorMap?.nameEnMap;
    if (!localeMap || isEn) {
      return key;
    }
    return localeMap?.[regionDataType]?.[key] || key;
  }, [selector, locale]);

  const getCodeText = useCallback((type, key) => {
    const isEn = locale === LANGUAGE_EN;
    if (localeKeyMap[key?.toLowerCase()]) {
      return isEn ? key : localeKeyMap[key.toLowerCase()];
    }
    if (!selector) return key;
    const localeMap = selectorMap?.nameCnMap;
    if (!localeMap) {
      return key;
    }

    if (isEn) {
      return localeMap?.[type]?.[key]?.en || key;
    } 
    return localeMap?.[type]?.[key]?.cn || localeMap?.[type]?.[key]?.en || key;
    
  }, [selector, locale]);

  // const countryNameCodeMap:any = useMemo(()=>{
  //   const countryNameCodeMap = {};
  //   const countryList = selector?.country_list || [];
  //   countryList?.forEach((item:any)=>{
  //     // @ts-ignore
  //     countryNameCodeMap[item?.country_name_en] = item?.country_code
  //   })
  //   return countryNameCodeMap;
  // },[selector])

  // // 根据国家名称获取国家code，用于获取国家国旗展示在表格中
  // const getCountryCode = (countryName:string)=>{
  //   return countryNameCodeMap?.[countryName] || ''
  // }

  return {
    usePcDateSelectorText,
    getCodeText,
    // getCountryCode,
    locale,
  };
};
